import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: ":curriculumProgramId",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "course-codes" */ "./components"),
      import(
        /* webpackChunkName: "course-codes" */ "./modules/CourseCodesModule"
      ),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;
      const reducer = importedModule1.default;

      injectReducer(store, {
        key: "courseCodes",
        reducer,
      });

      return component;
    })
  ),
});
